<template>

<div>
  <LDBsTable
    url="consultants"
    defaultSort="nome"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-6">
      <label for="consultant">{{ $t('consultant') }}</label>
      <Combobox
        class="bg-white"
        name='consultant'
        :placeholder="$t('select_a_item')"
        label="nome"
        :options="consultants"
        :initial-value="query.consultant"
        v-model="query.consultant"
        :reduce="consultant => consultant.id"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="month">{{ $t('month') }}</label>
      <Combobox
        class="bg-white"
        name='month'
        :placeholder="$t('select_a_item')"
        label="label"
        :options="months"
        :initial-value="query.month"
        v-model="query.month"
        :reduce="month => month.value"
      />
    </div>

    <div class="form-group col-lg-2">
      <label for="year">{{ $t('year') }}</label>
      <Combobox
        class="bg-white"
        name='year'
        :placeholder="$t('select_a_item')"
        :options="years"
        :initial-value="query.year"
        v-model="query.year"
      />
    </div>
  </LDBsTable>

  <!-- MODAL OS's -->
  <div
    ref='modalOss'
    id="modalOss"
    class="modal fade bd-example-modal-lg"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalOss"
    aria-hidden="true"
  >
    <div class="modal-xl modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">{{ consultant.toUpperCase() || '' }} - INSTALAÇÕES E RETIRADAS</h5>
        </div>

        <div class="modal-body">
          <b-table
            id='tableModal'
            responsive='xl'
            bordered
            hover
            :fields="fields"
            :items='oss'
            class="bg-white"
            :busy='busy'
          >
            <template v-slot:cell(client)=value>
              {{ value.item.client.nome_cliente }}
            </template>

            <template v-slot:cell(testDate)=value>
              {{ formatDate(value.item.testDate) }}
            </template>

            <template v-slot:cell(services)=value>
              {{ value.item.services == 1 ? 'INSTALAÇÃO' : 'RETIRADA' }}
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-secondary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
              </div>
            </template>

          </b-table>

          <div class="row text-right">
            <div class="col-12">
              <b-button class="mt-3" id='closeModal' data-dismiss="modal">{{ $t('close') }}</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL CLIENTS -->
  <div
    ref='modalClients'
    id="modalClients"
    class="modal fade bd-example-modal-lg"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalClients"
    aria-hidden="true"
  >
    <div class="modal-xl modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">{{ consultant.toUpperCase() || '' }} - CLIENTES DA CARTEIRA</h5>
        </div>

        <div class="modal-body">
          <b-table
            id='tableModal'
            bordered
            hover
            :fields="fieldsPayments"
            :items='payments'
            class="bg-white"
            :busy='busy'
            sticky-header="400px"
            responsive
          >
            <template v-slot:table-busy>
              <div class="text-center text-secondary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
              </div>
            </template>
          </b-table>

          <div class="mt-3 text-center text-dark">
            <h3>Total: {{ this.totalValuePayments.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</h3>
            <h3>Total de comissões: {{ this.totalValueComissions.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</h3>
          </div>

          <div class="row text-right">
            <div class="col-12">
              <b-button class="mt-3" id='closeModal' data-dismiss="modal">{{ $t('close') }}</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL LOADING -->
  <div
    ref='modalLoading'
    id="modalLoading"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalLoading"
    aria-hidden="true"
  >
    <div class="modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Carregando...</h5>
        </div>

        <div class="modal-body">
          <div class="d-flex justify-content-center mb-3">
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import LoaderButton from '@/components/button/LoaderButton'
import moment from 'moment'
import { request } from '@/lib/http'
import years from '@/config/years'
import months from '@/config/months'
import axios from 'axios'
import { apiBaseUrl } from '@/lib/config'

export default {
  name: 'Comission',
  components: {
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('consultant'),
          field: 'nome',
          formatter: (value, row) => {
            return value
              ? row.cpf ? value.toUpperCase() + ' / ' + row.cpf : value.toUpperCase()
              : '-'
          }
        },
        {
          title: this.$t('competence'),
          field: 'id',
          formatter: () => this.months[this.query.month].label + ' / ' + this.query.year
        },
        {
          title: this.$t('sales_goal'),
          field: 'meta_vendas',
          formatter: value => value ? value : ''
        },
        {
          title: this.$t('installations'),
          field: 'installations',
          formatter: value => value ? value : 0
        },
        {
          title: this.$t('withdrawals'),
          field: 'withdrawals',
          formatter: value => value ? value : 0
        },
        {
          title: this.$t('sales_goal_liquid'),
          field: 'meta_liquida',
          formatter: (value, row) => row.installations - row.withdrawals || 0
        },
        {
          title: this.$t('goal_reach_%'),
          field: 'meta_vendas',
          formatter: (value, row) => {
            if (!value) {
              return '-'
            }

            const liquid = row.installations - row.withdrawals || 0

            const percentage = ((liquid * 100) / value).toFixed(2) + '%'

            return percentage
          }
        },
        {
          title: this.$t('bonus_value'),
          field: 'valor_bonus',
          formatter: (value, row) => {
            if (row.tipo == 2) {
              return '-'
            }

            if (!row.meta_vendas) {
              return '-'
            }

            const liquid = row.installations - row.withdrawals

            const percentage = (liquid * 100) / row.meta_vendas

            return percentage >= 100
              ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              : 'R$ 0,00'
          },
          align: 'right'
        },
        {
          title: this.$t('active'),
          field: 'ativo',
          formatter: value => {
            return value
              ? 'SIM'
              : 'NÃO'
          },
          visible: false
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '150px',
          formatter: function (value, row) {
            return `
              <button
                title="OS's"
                data-target="#modalOss"
                data-id='${value}'
                data-name='${row.nome}'
                data-toggle="modal"
                class="edit mb-1 btn btn-action btn-primary btn-circle light-bottom-shadow text-white">
                <i class="fas fa-clipboard-list fa-lg" />
              </button>

              <button
                data-id='${value}'
                data-name='${row.nome}'
                data-toggle="modal"
                data-target="#modalClients"
                title="Clientes"
                class="printExtract mb-1 edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white">
                <i class="fas fa-users fa-lg" />
              </button>

              <button
                data-id='${value}'
                data-name='${row.nome}'
                data-toggle="modal"
                data-type='pdf'
                data-target="#modalLoading"
                title="Detalhes PDF"
                class="printExtract mb-1 edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white">
                <i class="fas fa-file-pdf fa-lg" />
              </button>

              <button
                data-id='${value}'
                data-name='${row.nome}'
                data-type='csv'
                data-toggle="modal"
                data-target="#modalLoading"
                title="Detalhes CSV"
                class="printExtract mb-1 edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white">
                <i class="fas fa-file-csv fa-lg" />
              </button>
            `
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'Comissões' }
      },
      months,
      query: {
        consultant: undefined,
        month     : moment().month() == 0 ? 11 : moment().month() -1,
        year      : moment().year()
      },
      consultants: [],
      years,
      busy: false,
      fields: [
        { key: 'testDate', label: this.$t('date') },
        { key: 'client',   label: this.$t('client') },
        { key: 'board',    label: this.$t('board') },
        { key: 'services', label: this.$t('services') }
      ],
      fieldsPayments: [
        {
          key: 'tipo_boleto',
          label: this.$t('reference'),
          formatter: value => {
            if (value == 1) {
              return 'Mensalidade'
            }

            if (value == 4) {
              return 'Taxa de Instalação'
            }

            return value
          }
        },
        {
          key: 'nome_cliente',
          label: this.$t('client')
        },
        {
          key: 'valor_original_boleto',
          label: this.$t('value'),
          formatter: value => value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
          class: 'text-right'
        },
        {
          key: 'valor_boleto',
          label: this.$t('comission') + ' (%)',
          formatter: (value, row, el) => {
            if (el.tipo_boleto == 1) {
              const comission = el.comissao_mensalidade || 0
              return comission + '%'
            }

            if (el.tipo_boleto == 4) {
              const comission = el.comissao_instalacao || 0
              return comission + '%'
            }

            return '0%'
          },
          class: 'text-right'
        },
        {
          key: 'valor_bruto_boleto',
          label: this.$t('comission') + ' (R$)',
          formatter: (value, row, el) => {
            if (el.tipo_boleto == 1) {
              return ((el.comissao_mensalidade / 100) * el.valor_original_boleto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            }

            if (el.tipo_boleto == 4) {
              return ((el.comissao_instalacao / 100) * el.valor_original_boleto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            }

            return 'R$ 0,00'
          },
          class: 'text-right'
        },
      ],
      oss: [],
      payments: [],
      totalValuePayments: 0,
      totalValueComissions: 0,
      consultant: ''
    }
  },

  watch: {
    'query.month': function(value) {
      this.query.month = value == null
        ? moment().month() == 0
          ? 11
          : moment().month() -1
        : value
    },

    'query.year': function(value) {
      if (!value) {
        this.query.year = moment().year()
      }
    }
  },

  methods: {
    clear() {
      this.query.consultant = undefined,
      this.query.year       = moment().year(),
      this.query.month      = moment().month() == 0 ? 11 : moment().month() -1
    },

    async getOss(id) {
      this.busy = true

      try {
        const { oss } = await request({
          url   : `list-os-by-consultant`,
          method: 'get',
          params: {
            consultant: id,
            month: this.query.month,
            year : this.query.year
          }
        })

        this.oss = oss
      } catch (error) {
      } finally {
        this.busy = false
      }
    },

    async getClients(id) {
      this.busy = true

      try {
        const payments = await request({
          url   : `clients-by-consultant`,
          method: 'get',
          params: {
            consultant: id,
            month: this.query.month,
            year : this.query.year
          }
        })

        this.payments = payments
        const sumTotalValueComissions = (comission, originalValue) => this.totalValueComissions += (comission / 100) * originalValue

        for (const payment of payments) {
          this.totalValuePayments += payment.valor_original_boleto

          if (payment.tipo_boleto == 1) {
            sumTotalValueComissions(payment.comissao_mensalidade, payment.valor_original_boleto)
          }

          if (payment.tipo_boleto == 4) {
            sumTotalValueComissions(payment.comissao_instalacao, payment.valor_original_boleto)
          }
        }

      } catch (error) {
      } finally {
        this.busy = false
      }
    },

    async printDetails(id, type = 'pdf') {
      try {
        const { token, sessionId } = JSON.parse(localStorage.getItem('auth_data'))

        if (type === 'pdf') {
          const { data } = await axios({
            url   : `${apiBaseUrl()}details-comission-consultant`,
            method: 'get',
            params: {
              consultant: id,
              month     : this.query.month,
              year      : this.query.year,
              type      : 'pdf'
            },
            headers: {
              'Authorization': `Bearer ${token}`,
              'api-session-id': sessionId
            },
          })

          axios({
            url: 'https://relatorios.maxfrota.com.br:8080/?debug=1',
            method: 'post',
            data,
            responseType: 'blob'
          })
            .then(response => {
              const file = new Blob(
                [response.data],
                { type: 'application/pdf' }
              )
              const fileURL = URL.createObjectURL(file)
              window.open(fileURL, "_blank")
          })
            .catch(error => {
              console.log(error)
          })
        }

        if (type === 'csv') {
          const data = await axios.get(
            `${apiBaseUrl()}details-comission-consultant`,
            {
              params: {
                consultant: id,
                month     : this.query.month,
                year      : this.query.year,
                type      : 'csv'
              },
              headers: {
                'Authorization': `Bearer ${token}`,
                'api-session-id': sessionId
              },
              responseType: 'blob'
            }
          )

          const { nome } = this.consultants.find(consultant => consultant.id == id)
          const filename = `COMISSOES_${nome.toUpperCase()}_${this.query.month + 1}_${this.query.year}`

          const url  = window.URL.createObjectURL(new Blob([data.data], { type: 'text/csv; charset=latin1' }))
          const link = document.createElement('a')
          link.href  = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        }
      } catch (error) {
        console.log(`[ERROR-PRINT-DETAILS-${type.toUpperCase()}]`, error)
      } finally {
        setTimeout(() => $('#modalLoading').modal('hide'), 500)
      }
    },

    formatDate(date) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
    }
  },

  async mounted() {
    this.consultants = await request({
      url   : 'consultants',
      method: 'get'
    })

    const global = this
    $('#modalOss').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      global.consultant = button.data('name')

      global.getOss(button.data('id'))
    })

    $('#modalClients').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      global.consultant = button.data('name')

      global.getClients(button.data('id'))
    })

    $('#modalOss').on('hide.bs.modal', function (event) {
      global.consultant = ''
    })

    $('#modalClients').on('hide.bs.modal', function (event) {
      global.totalValuePayments   = 0
      global.totalValueComissions = 0
      global.consultant           = ''
    })

    $('#modalLoading').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)

      global.printDetails(button.data('id'), button.data('type'))
    })
  }
}
</script>
